import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

const GOOGLE_SCRIPT_URL = process.env.REACT_APP_GOOGLE_SCRIPT_URL;

export const submitContact = async (payload) => {
  const response = await fetch(GOOGLE_SCRIPT_URL, {
    method: "POST",
    headers: {
      "Content-Type": "text/plain;charset=utf-8"
    },
    body: JSON.stringify({
      name: payload.name,
      email: payload.email,
      phone: payload.phonenumber,
      company: payload.company,
      message: payload.message,
      interest: payload.interest,
      source: "Deployedd Website"
    })
  });

  return response.json();
};

export const subscribeNewsletter = (email) => api.post("/newsletter", { email }).then((r) => r.data);
export const fetchBlog = () => api.get("/blog").then((r) => r.data);
export const fetchBlogPost = (slug) => api.get(`/blog/${slug}`).then((r) => r.data);
export const fetchCaseStudies = () => api.get("/case-studies").then((r) => r.data);
export const fetchCaseStudy = (slug) => api.get(`/case-studies/${slug}`).then((r) => r.data);
export const fetchPrograms = () => api.get("/programs").then((r) => r.data);
export const fetchSocialPosts = () => api.get("/social").then((r) => r.data);
